export class ConsentViewState {
  consentDocumentAction?: boolean; //determines if an action has occurred in wet signature section (upload)
  consentDocumentMode?: boolean; //determines if user has seen consent document (wet signature) fields
  digitalVerificationMode?: boolean; //determines if user has seen digital verification fields
}
